import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useChangePassword = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const { language } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-change-password'], queryFn: async ({ signal }) => {
            let url = new URL('/consumer/booking/changePassword', ConfigHolder.apiBaseUrl);
            url.searchParams.set('api_lang', language);
            const data = {
                password: formContext.getValues('password'),
                password2: formContext.getValues('password'),
                customerHash: formContext.getValues('hash'),
                customerId: formContext.getValues('id'),
                key: api_key
            };
            let body = new URLSearchParams(data);
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST", // this request is GET in the old widget
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-OAnl-csrf-protection': 'on',
                    'accept': '*/*',
                },
                body: body
            });
            return response.json();
        } }));
};
